var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useState, useEffect } from 'react';
import { Button } from 'react-bootstrap';
import { render } from 'react-dom';
import axios from './axios';
import { handleBrowzerBack } from './BrowzerBack';
import DialogConfirm from './molecules/DialogConfirm';
import ResultDialog from './molecules/Dialog';
import LoadingModal from './organisms/LoadingModal';
import Messages from './molecules/Messages';
import { inputAssistDigit } from './Convert';
var Debug = function () {
    // 検索フォームの現在の入力状態
    var _a = useState(''), search_reception_cd = _a[0], setSearchReceptionCd = _a[1];
    var _b = useState('01'), search_reception_sub_cd = _b[0], setSearchReceptionSubCd = _b[1];
    var _c = useState([]), search_type_items = _c[0], setSearchTypeItems = _c[1];
    var _d = useState(''), search_type = _d[0], setSearchType = _d[1];
    // 検索ボタン押下時の検索ステータス
    var _e = useState({
        reception_cd: '',
        reception_sub_cd: '',
        type: '',
    }), searching_params = _e[0], setSearchingParams = _e[1];
    // 検索結果
    var _f = useState({
        id: '',
        value: '',
    }), result = _f[0], setResult = _f[1];
    // 接続中ステータス
    var _g = useState(true), is_connecting = _g[0], setIsConnecting = _g[1];
    // エラーメッセージ
    var _h = useState(''), error_message = _h[0], setErrorMessage = _h[1];
    // ダイアログの表示制御
    var _j = useState(false), is_confirm_show = _j[0], setIsConfirmShow = _j[1];
    var _k = useState(false), is_dialog_show = _k[0], setIsDialogShow = _k[1];
    var _l = useState(''), dialog_message = _l[0], setDialogMessage = _l[1];
    // onload
    useEffect(function () {
        // ブラウザの戻る・進む禁止
        handleBrowzerBack();
        var getProjectTypes = function () { return __awaiter(void 0, void 0, void 0, function () {
            var response, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, 3, 4]);
                        return [4 /*yield*/, axios.get('/debug/list')];
                    case 1:
                        response = _a.sent();
                        setSearchTypeItems(response.data.projects_col_keys);
                        // 項目の初期値を設定する
                        setSearchType(response.data.projects_col_keys[0].key);
                        return [3 /*break*/, 4];
                    case 2:
                        error_1 = _a.sent();
                        console.error(error_1.message);
                        return [3 /*break*/, 4];
                    case 3:
                        setIsConnecting(false);
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        // Ajaxリクエスト
        getProjectTypes();
    }, []);
    // 検索フォームの変更イベント
    var handleChangeSearchReceptionCd = function (event) {
        setSearchReceptionCd(event.target.value);
    };
    var handleBlurSearchReceptionCd = function () {
        setSearchReceptionCd(inputAssistDigit(search_reception_cd));
    };
    var handleChangeSearchReceptionSubCd = function (event) {
        setSearchReceptionSubCd(event.target.value);
    };
    var handleChangeSearchType = function (event) {
        setSearchType(event.target.value);
    };
    // 検索結果の変更イベント
    var handleChangeResult = function (event) {
        var newResult = result;
        newResult.value = event.target.value;
        setResult(Object.assign({}, newResult));
    };
    // 検索ボタン押下
    var handleClickSearch = function () {
        // バリデーション
        if (!isValidInput()) {
            return false;
        }
        // エラーメッセージを削除
        setErrorMessage('');
        // 検索中フラグを立てる
        setIsConnecting(true);
        // 検索を実行する
        searchReception();
    };
    // 検索処理
    var searchReception = function () {
        var search = function () { return __awaiter(void 0, void 0, void 0, function () {
            var params, response, newResult, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, 3, 4]);
                        params = {
                            reception_cd: search_reception_cd,
                            reception_sub_cd: search_reception_sub_cd,
                            type: search_type,
                        };
                        return [4 /*yield*/, axios.post('/debug/search', params)];
                    case 1:
                        response = _a.sent();
                        // 案件が見つからなかった場合
                        if (!response.data.result) {
                            setErrorMessage(response.data.message);
                            return [2 /*return*/, false];
                        }
                        newResult = result;
                        newResult.id = response.data.id;
                        newResult.value = response.data.value !== null ? response.data.value : '';
                        setResult(Object.assign({}, newResult));
                        // 案件が見つかったら検索中コードをstateに保持する
                        setSearchingParams(params);
                        return [3 /*break*/, 4];
                    case 2:
                        error_2 = _a.sent();
                        console.error(error_2.message);
                        setErrorMessage('案件が見つかりませんでした。');
                        return [3 /*break*/, 4];
                    case 3:
                        setIsConnecting(false);
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        search();
    };
    // バリデーション
    var isValidInput = function () {
        if (search_reception_cd === null ||
            typeof search_reception_cd === 'undefined' ||
            search_reception_cd.length === 0) {
            setErrorMessage('案件番号を入力してください。');
            return false;
        }
        if (search_reception_sub_cd === null ||
            typeof search_reception_sub_cd === 'undefined' ||
            search_reception_sub_cd.length === 0) {
            setErrorMessage('案件枝番号を入力してください。');
            return false;
        }
        if (search_type === null || typeof search_type === 'undefined' || search_type.length === 0) {
            setErrorMessage('項目を入力してください。');
            return false;
        }
        return true;
    };
    // 更新ボタン押下
    var handleClickUpdate = function () {
        setErrorMessage('');
        setIsConfirmShow(true);
    };
    // 確認ダイアログ
    // はいボタン
    var handleConfirmYes = function () {
        var update = function () { return __awaiter(void 0, void 0, void 0, function () {
            var message, params, response, error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        message = null;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        params = {
                            rec_id: result.id,
                            col_name: searching_params.type,
                            value: result.value,
                        };
                        return [4 /*yield*/, axios.post('/debug/update', params)];
                    case 2:
                        response = _a.sent();
                        message = response.data.message;
                        return [3 /*break*/, 5];
                    case 3:
                        error_3 = _a.sent();
                        console.error(error_3.message);
                        message = '更新に失敗しました。';
                        return [3 /*break*/, 5];
                    case 4:
                        setIsConnecting(false);
                        setDialogMessage(message);
                        setIsDialogShow(true);
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        setIsConfirmShow(false);
        setIsConnecting(true);
        update();
    };
    return (React.createElement("div", { className: "container" },
        React.createElement("div", { className: "announce" },
            React.createElement("p", null, "\u6848\u4EF6\u756A\u53F7\u3068\u6848\u4EF6\u679D\u756A\u53F7\u3068\u9805\u76EE\u3092\u5165\u529B\u3057\u3001\u66F4\u65B0\u5BFE\u8C61\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044\u3002")),
        React.createElement("div", { className: "search row" },
            React.createElement("div", { className: "col-md-3" },
                React.createElement("span", null, "\u6848\u4EF6\u756A\u53F7"),
                React.createElement("input", { type: "text", value: search_reception_cd, onChange: handleChangeSearchReceptionCd, onBlur: handleBlurSearchReceptionCd })),
            React.createElement("div", { className: "col-md-2" },
                React.createElement("span", null, "\u6848\u4EF6\u679D\u756A\u53F7"),
                React.createElement("select", { value: search_reception_sub_cd, onChange: handleChangeSearchReceptionSubCd },
                    React.createElement("option", { value: "01" }, "01"),
                    React.createElement("option", { value: "02" }, "02"))),
            React.createElement("div", { className: "col-md-5" },
                React.createElement("span", null, "\u9805\u76EE"),
                React.createElement("select", { defaultValue: search_type, onChange: handleChangeSearchType }, search_type_items === null || search_type_items === void 0 ? void 0 : search_type_items.map(function (option, index) {
                    return (React.createElement("option", { key: index, value: option.key }, option.value));
                }))),
            React.createElement("div", { className: "col-md-2" },
                React.createElement(Button, { onClick: handleClickSearch }, "\u691C\u7D22"))),
        React.createElement("div", { className: "messages" },
            React.createElement(Messages, { valid_msg: error_message })),
        React.createElement("div", { className: "result row" },
            React.createElement("div", { className: "result-body col-md-10" },
                React.createElement("span", null, "\u691C\u7D22\u7D50\u679C"),
                React.createElement("textarea", { value: result.value, onChange: handleChangeResult })),
            React.createElement("div", { className: "update col-md-2" },
                React.createElement(Button, { className: "update-button", onClick: handleClickUpdate }, "\u66F4\u65B0"))),
        React.createElement(DialogConfirm, { label: "\u66F4\u65B0\u78BA\u8A8D", body: React.createElement("p", null, "\u66F4\u65B0\u3057\u307E\u3059\u304B\uFF1F"), ok: "\u306F\u3044", okCallback: handleConfirmYes, cancel: "\u3044\u3044\u3048", cancelCallback: function () {
                setIsConfirmShow(false);
            }, open: is_confirm_show }),
        React.createElement(ResultDialog, { label: "\u66F4\u65B0\u7D50\u679C", body: React.createElement("p", null, dialog_message), ok: 'OK', okCallback: function () {
                setIsDialogShow(false);
            }, open: is_dialog_show }),
        React.createElement(LoadingModal, { show: is_connecting })));
};
if (document.getElementById('debug')) {
    render(React.createElement(Debug, null), document.getElementById('debug'));
}
